import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mr-3 provider-summary-avatar" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "text-truncate" }
const _hoisted_5 = { class: "d-flex align-center" }
const _hoisted_6 = { class: "d-flex flex-wrap align-center flex-grow-1" }
const _hoisted_7 = { class: "pt-2" }
const _hoisted_8 = {
  key: 0,
  class: "card-action-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_SecretInput = _resolveComponent("SecretInput")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_AudioPlayer = _resolveComponent("AudioPlayer")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "ma-0 pa-2 card",
    color: "background",
    variant: "elevated",
    elevation: _ctx.isOverlay ? 0 : 4,
    density: "compact"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_form, {
        class: "ma-0 pa-0",
        onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"])),
        density: "compact",
        autocomplete: "off"
      }, {
        default: _withCtx(() => [
          _cache[19] || (_cache[19] = _createElementVNode("input", {
            id: "username",
            autocomplete: "username",
            type: "text",
            style: {"display":"none"}
          }, null, -1)),
          _cache[20] || (_cache[20] = _createElementVNode("input", {
            id: "password",
            autocomplete: "new-password",
            type: "password",
            style: {"display":"none"}
          }, null, -1)),
          (!_ctx.show)
            ? (_openBlock(), _createBlock(_component_v_card_item, {
                key: 0,
                class: "provider-summary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show = true))
              }, {
                prepend: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (_ctx.showStandaloneIcon && _ctx.iconMode !== 'mono')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: (_ctx.icon as ProviderIcon).src,
                          alt: `${_ctx.displayName} icon`,
                          class: "provider-summary-avatar-image",
                          onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onIconError && _ctx.onIconError(...args)))
                        }, null, 40, _hoisted_2))
                      : (_ctx.showStandaloneIcon)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "provider-summary-avatar-mask",
                            style: _normalizeStyle(_ctx.iconMaskStyle),
                            role: "img",
                            "aria-label": `${_ctx.displayName} icon`
                          }, null, 12, _hoisted_3))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            class: "provider-summary-initials",
                            style: _normalizeStyle({ backgroundColor: _ctx.brandColor })
                          }, _toDisplayString(_ctx.providerInitials), 5))
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.displayName), 1),
                      (_ctx.hasLLM)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            size: "x-small",
                            class: "ml-2"
                          }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createTextVNode("LLM")
                            ])),
                            _: 1,
                            __: [11]
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.hasAudio)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 1,
                            size: "x-small",
                            class: "ml-2"
                          }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode("Voice")
                            ])),
                            _: 1,
                            __: [12]
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_subtitle, { class: "text-truncate" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.providerSubtitle), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.show)
            ? (_openBlock(), _createBlock(_component_v_card_text, {
                key: 1,
                class: "pt-0 pb-0 provider-summary-text"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_v_chip, {
                        size: "small",
                        variant: "tonal",
                        class: "mr-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.llmModels.length) + " models", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_chip, {
                        size: "small",
                        variant: "tonal",
                        class: "mr-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.voiceModels.length) + " voices", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    (!_ctx.isOverlay)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          color: "primary",
                          icon: "mdi-chevron-down",
                          size: "large",
                          variant: "plain",
                          class: "provider-summary-expand",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.show = true), ["stop"]))
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_expand_transition, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_v_list, {
                class: "ma-0 pa-0 card-content",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showGlobalTooltips)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            position: "top",
                            "max-width": "300",
                            text: "Select a built-in provider or enter a unique name for a custom provider."
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps(props, {
                                size: "x-small",
                                class: "global-tooltip-icon mt-5 ml-n6"
                              }), {
                                default: _withCtx(() => _cache[13] || (_cache[13] = [
                                  _createTextVNode("mdi-information-outline")
                                ])),
                                _: 2,
                                __: [13]
                              }, 1040)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_combobox, {
                        modelValue: _ctx.providerKeyValue,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = ($event: any) => ((_ctx.providerKeyValue) = $event)),
                          _ctx.providerKeyUpdated
                        ],
                        items: _ctx.builtInProviders,
                        label: "Provider Name",
                        class: "pt-2",
                        variant: "outlined",
                        density: "compact",
                        rules: [() => !!_ctx.providerKeyValue || 'Provider Name is required']
                      }, {
                        "append-inner": _withCtx(() => [
                          (_ctx.isCustomProvider)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                text: "Custom Provider"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                    color: "primary",
                                    icon: "mdi-pencil-outline"
                                  }), null, 16)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  (_ctx.isCustomProvider)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 0,
                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.showGlobalTooltips)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                position: "top",
                                "max-width": "300",
                                text: "URL is required for custom providers (e.g., http://localhost:11434)."
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                    size: "x-small",
                                    class: "global-tooltip-icon mt-5 ml-n6"
                                  }), {
                                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                                      _createTextVNode("mdi-information-outline")
                                    ])),
                                    _: 2,
                                    __: [14]
                                  }, 1040)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.url,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.url) = $event)),
                            onBlur: _ctx.checkChanges,
                            label: "Provider URL",
                            class: "pt-2",
                            variant: "outlined",
                            density: "compact",
                            rules: [() => !_ctx.isCustomProvider || !!_ctx.url || 'URL is required for custom providers']
                          }, null, 8, ["modelValue", "onBlur", "rules"])
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showGlobalTooltips)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            position: "top",
                            "max-width": "300",
                            text: _ctx.apiKeyTooltipText
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps(props, {
                                size: "x-small",
                                class: "global-tooltip-icon mt-5 ml-n6"
                              }), {
                                default: _withCtx(() => _cache[15] || (_cache[15] = [
                                  _createTextVNode("mdi-information-outline")
                                ])),
                                _: 2,
                                __: [15]
                              }, 1040)
                            ]),
                            _: 1
                          }, 8, ["text"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_SecretInput, {
                        modelValue: _ctx.apiKey,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.apiKey) = $event)),
                        onBlur: _ctx.checkChanges,
                        label: _ctx.apiKeyLabel,
                        class: "pt-2",
                        rules: [() => _ctx.isCustomProvider || !!_ctx.apiKey || 'API Key is required for built-in providers']
                      }, null, 8, ["modelValue", "onBlur", "label", "rules"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showGlobalTooltips)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            position: "top",
                            "max-width": "300",
                            text: "Select provider capabilities. When omitted, API defaults to ['llm']."
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps(props, {
                                size: "x-small",
                                class: "global-tooltip-icon mt-5 ml-n6"
                              }), {
                                default: _withCtx(() => _cache[16] || (_cache[16] = [
                                  _createTextVNode("mdi-information-outline")
                                ])),
                                _: 2,
                                __: [16]
                              }, 1040)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_7, [
                        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-caption mb-1" }, "Provider Capabilities", -1)),
                        _createVNode(_component_v_checkbox, {
                          modelValue: _ctx.hasLLM,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.hasLLM) = $event)),
                          label: "LLM",
                          density: "compact",
                          "hide-details": "",
                          class: "display-inline mr-4"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_checkbox, {
                          modelValue: _ctx.hasAudio,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.hasAudio) = $event)),
                          label: "Audio",
                          density: "compact",
                          "hide-details": "",
                          class: "display-inline"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  (_ctx.llmModels.length + _ctx.voiceModels.length > 0)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 1,
                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.showGlobalTooltips)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                position: "top",
                                "max-width": "300",
                                text: "Inventory discovered for this provider. Models and voices are grouped below."
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                    size: "x-small",
                                    class: "global-tooltip-icon mt-5 ml-n6"
                                  }), {
                                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                                      _createTextVNode("mdi-information-outline")
                                    ])),
                                    _: 2,
                                    __: [18]
                                  }, 1040)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_expansion_panels, { class: "pt-2 w-100" }, {
                            default: _withCtx(() => [
                              (_ctx.llmModels.length > 0)
                                ? (_openBlock(), _createBlock(_component_v_expansion_panel, {
                                    key: 0,
                                    title: `Supported LLM Models (${_ctx.llmModels.length})`,
                                    density: "compact",
                                    color: "background",
                                    class: "card-content"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_expansion_panel_text, { class: "card-content" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list, {
                                            density: "compact",
                                            class: "card-content"
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.llmModels, (item) => {
                                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                                  key: (item as any).id,
                                                  density: "compact"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.id), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              }), 128))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["title"]))
                                : _createCommentVNode("", true),
                              (_ctx.voiceModels.length > 0)
                                ? (_openBlock(), _createBlock(_component_v_expansion_panel, {
                                    key: 1,
                                    title: `Supported Voices (${_ctx.voiceModels.length})`,
                                    density: "compact",
                                    color: "background"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_expansion_panel_text, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list, { density: "compact" }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.voiceModels, (item) => {
                                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                                  key: item.id,
                                                  density: "compact"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("span", null, _toDisplayString(item.name ?? item.id), 1),
                                                        (item.labels && item.labels.descriptive)
                                                          ? (_openBlock(), _createBlock(_component_v_chip, {
                                                              key: 0,
                                                              size: "x-small",
                                                              class: "ml-2",
                                                              color: "info"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(item.labels.descriptive), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024))
                                                          : _createCommentVNode("", true),
                                                        (item.labels && item.labels.accent)
                                                          ? (_openBlock(), _createBlock(_component_v_chip, {
                                                              key: 1,
                                                              size: "x-small",
                                                              class: "ml-2",
                                                              color: _ctx.accentChipColor(item.labels.accent)
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(item.labels.accent), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["color"]))
                                                          : _createCommentVNode("", true),
                                                        (item.labels && item.labels.gender)
                                                          ? (_openBlock(), _createBlock(_component_v_chip, {
                                                              key: 2,
                                                              size: "x-small",
                                                              class: "ml-2",
                                                              color: _ctx.genderChipColor(item.labels.gender)
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(item.labels.gender), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["color"]))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    (item.previewUrl)
                                                      ? (_openBlock(), _createBlock(_component_AudioPlayer, {
                                                          key: `${_ctx.audioColor}:${item.previewUrl}`,
                                                          src: item.previewUrl,
                                                          "canv-height": 40,
                                                          "canv-width": 300,
                                                          "bar-color": _ctx.audioColor,
                                                          "show-controls": true
                                                        }, null, 8, ["src", "bar-color"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              }), 128))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["title"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.show]
              ])
            ]),
            _: 1
          }),
          (_ctx.show)
            ? (_openBlock(), _createBlock(_component_v_card_actions, {
                key: 2,
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Button, {
                    color: "primary",
                    class: "mr-4",
                    disabled: _ctx.saveDisabled,
                    click: _ctx.updateProvider,
                    icon: "mdi-check-bold",
                    size: "x-large",
                    tooltip: "Save Provider",
                    density: "compact"
                  }, null, 8, ["disabled", "click"]),
                  _createVNode(_component_Button, {
                    color: "primary",
                    class: "mr-4",
                    click: _ctx.initiateDeleteProvider,
                    icon: "mdi-trash-can-outline",
                    size: "x-large",
                    tooltip: "Delete Provider",
                    density: "compact"
                  }, null, 8, ["click"]),
                  _createVNode(_component_v_spacer),
                  (!_ctx.isOverlay)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        color: "primary",
                        class: "mx-auto",
                        icon: "mdi-chevron-up",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.show = false)),
                        density: "compact"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1,
        __: [19,20]
      }),
      (_ctx.waiting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.actionMessage), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_ConfirmationDialog, {
        modelValue: _ctx.showDeleteConfirmationDialog,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showDeleteConfirmationDialog) = $event)),
        title: "Confirm Provider Deletion",
        message: "Are you sure you want to delete this provider?",
        itemName: _ctx.providerToDeleteName,
        itemType: "provider",
        loading: _ctx.waiting,
        onConfirm: _ctx.confirmProviderDelete,
        onCancel: _ctx.cancelDeleteProvider
      }, null, 8, ["modelValue", "itemName", "loading", "onConfirm", "onCancel"])
    ]),
    _: 1
  }, 8, ["elevation"]))
}